var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplicationRolesSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "application-roles-small-a",
    d: "M0 0h16v16H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "application-roles-small-b-id-1",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#application-roles-small-a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "nonzero",
    d: "M6.318 10.7c.562-.003 1.02.45 1.023 1.014v3.274a1.019 1.019 0 0 1-1.023 1.015l-5.296-.01A1.017 1.017 0 0 1 0 14.98v-3.268A1.017 1.017 0 0 1 1.02 10.7h5.298zm8.662-4.076c.565.001 1.022.46 1.02 1.024v7.32a1.023 1.023 0 0 1-1.02 1.025l-5.299.01a1.023 1.023 0 0 1-1.022-1.024v-7.33a1.022 1.022 0 0 1 1.02-1.025h5.301zm-8.66 4.794H1.018a.3.3 0 0 0-.3.296v3.264a.3.3 0 0 0 .302.298l5.3.01a.301.301 0 0 0 .304-.299v-3.271a.3.3 0 0 0-.304-.298zm8.66-4.077h-5.3a.305.305 0 0 0-.304.307v7.33c0 .17.136.307.305.308l5.298-.01a.306.306 0 0 0 .303-.307V7.647a.304.304 0 0 0-.303-.306zM1.021.001l5.3.008c.564.002 1.02.461 1.019 1.024v7.322A1.023 1.023 0 0 1 6.32 9.379h-5.3A1.022 1.022 0 0 1 0 8.355v-7.33A1.023 1.023 0 0 1 1.022 0zm0 .716a.306.306 0 0 0-.305.308v7.33c0 .17.136.306.304.307H6.32a.305.305 0 0 0 .305-.307V1.033A.306.306 0 0 0 6.32.726L1.022.717zM14.974 0A1.019 1.019 0 0 1 16 1.012v3.279a1.017 1.017 0 0 1-1.021 1.012H9.683a1.017 1.017 0 0 1-1.024-1.012V1.02A1.015 1.015 0 0 1 9.679.01L14.973 0zm.004.717l-5.301.01c-.165-.002-.3.131-.3.294V4.29a.3.3 0 0 0 .303.296h5.3a.3.3 0 0 0 .303-.297V1.016a.301.301 0 0 0-.305-.299z",
    mask: "url(#application-roles-small-b)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplicationRolesSmall);
export default __webpack_public_path__ + "static/media/application-roles-small.10875ba9f68fcb45b8eb2c16b34e75ea.svg";
export { ForwardRef as ReactComponent };